// Libraries
import React from 'react';
// Layouts
import {CssGrid, CssGridRow, CssGridColumn} from '../layouts/CssGrid';


export default class TwoColumnLayout extends React.Component {
    render() {
        const {column1, column2} = this.props;

        return <div>
            <CssGrid>
                <CssGridRow>
                    <CssGridColumn sizePhone={4} sizeTablet={4} size={6}>
                        {column1}
                    </CssGridColumn>
                    <CssGridColumn sizePhone={0} sizeTablet={4} size={6}>
                        {column2}
                    </CssGridColumn>
                </CssGridRow>
                <CssGridRow>
                    <CssGridColumn sizePhone={4} sizeTablet={0} size={0}>
                        {column2}
                    </CssGridColumn>
                </CssGridRow>
            </CssGrid>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/layouts/TwoColumnLayout.jsx